import React from "react";
import { useParams } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext.jsx";
import PatientProfile from "@/pages/profile/patient/PatientProfile.jsx";
import { loadClinicianAppointmentPatientIdentities } from "@/services/patientIdentityService.js";

export default function ClinicianAppointmentPatientProfile() {
  const { appointmentId } = useParams();
  const { t } = useLanguage();
  const [result, setResult] = React.useState({ loading: true, context: null });

  React.useEffect(() => {
    let alive = true;
    setResult({ loading: true, context: null });
    loadClinicianAppointmentPatientIdentities([{ id: appointmentId }])
      .then((identities) => {
        if (!alive) return;
        const identity = identities.get(String(appointmentId || ""));
        if (!identity || !identity.patientUserId || identity.careSubjectType === "dependant") {
          setResult({ loading: false, context: null });
          return;
        }
        const patient = {
          id: identity.patientRowId,
          patient_id: identity.patientRowId,
          user_id: identity.patientUserId,
          full_name: identity.patientLegalName || identity.patientName,
          name: identity.patientName,
          salutation: identity.patientProfile?.salutation || "",
          last_name: identity.patientProfile?.last_name || "",
          date_of_birth: identity.patientProfile?.date_of_birth || null,
          profile_photo_path: identity.patientProfile?.profile_photo_path || "",
          profile_image_url: identity.avatar,
          avatar_url: identity.avatar,
        };
        setResult({ loading: false, context: {
          from: "doctor",
          appointmentId,
          patientId: identity.patientRowId,
          patientUserId: identity.patientUserId,
          patient,
          ehrGranted: false,
        } });
      })
      .catch(() => { if (alive) setResult({ loading: false, context: null }); });
    return () => { alive = false; };
  }, [appointmentId]);

  if (result.loading) return <main className="p-6">{t("patient.profile.loading", "Loading patient profile…")}</main>;
  if (!result.context) return <main className="p-6" role="alert">{t("patient.profile.appointmentContextUnavailable", "Patient profile is unavailable for this appointment.")}</main>;
  return <PatientProfile key={`${appointmentId}:${result.context.patientUserId}`} clinicianContext={result.context} />;
}
